export const CLIP_STATUS_VALUES = [
    'pending',
    'rendering',
    'ready',
    'approved',
    'rejected',
    'error',
];
export const SUBTITLE_POSITION_VALUES = ['top', 'middle', 'bottom'];
export const CLIP_BACKGROUND_MODE_VALUES = ['blur', 'letterbox', 'video', 'black'];
/** How the variant's banner is applied on the timeline:
 *  - 'overlay' — banner over the playing clip between startSec/endSec (classic);
 *  - 'freeze'  — the clip freezes at freezeAtSec for freezeDurationSec, the
 *    banner (with its audio) plays over the frozen frame, then the clip
 *    resumes. Output is longer than the clip by freezeDurationSec. */
export const BANNER_TIMING_MODE_VALUES = ['overlay', 'freeze'];
//# sourceMappingURL=clip.js.map